<template>
    <div name="partners-footer" class="partners-footer">
        <div class="wrapper">
            <a
                href="https://soldoc.co.kr/"
                target="_blank"
                title="새창으로 열림"
                class="btn-text"
                >솔닥 소개</a
            >
            <span class="line">|</span>
            <a
                href="https://policy.soldoc.co.kr/partners/terms"
                target="_blank"
                title="새창으로 열림"
                class="btn-text"
                >이용약관</a
            >
            <span class="line">|</span>
            <a
                href="https://policy.soldoc.co.kr/partners/use?is_medical=true"
                target="_blank"
                title="새창으로 열림"
                class="btn-text"
                >개인정보 수집 및 이용 동의</a
            >
        </div>
        <div class="wrapper" style="margin-top: 25px">
            <span class="text"
                >솔닥 회사명 : 솔닥 주식회사 | 대표 : 김민승, 이호익 |
                사업자등록번호 : 284-87-00967 | 통신판매업신고번호 :
                2021-서울강남-06329호<br />서울특별시 강남구 도산대로 174,
                7층(정안빌딩) | E-mail : partner@soldoc.co.kr | 대표번호 :
                02-6954-7681 | 개인정보관리자 : 김민승</span
            >
        </div>
        <div class="wrapper" style="margin-top: 70px">
            <span class="text"
                >Copyright ⓒ soldoc.co.kr All rights reserved.</span
            >
        </div>
        <a
            href="https://soldoc.channel.io/support-bots/21826"
            target="_blank"
            title="새창으로 열림"
            class="btn-help"
        >
            <img src="../../assets/basic/pc/help.png" alt="솔닥 고객센터" />
            <span>솔닥 고객센터</span>
        </a>
    </div>
</template>

<script>
export default {
    name: "partners-footer",
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll() {
            const currentScrollTop = window.scrollY;
            const currentHeight = window.innerHeight;
            const btnHep = document.querySelector(".btn-help");

            if (currentScrollTop > currentHeight) {
                btnHep.style.display = "flex";
            } else {
                btnHep.style.display = "none";
            }
        },
    },
};
</script>

<style scoped>
.btn-help {
    width: 178px;
    height: 56px;
    background: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
    border-radius: 54px;
    position: fixed;
    bottom: 57px;
    right: 30%;
    transform: translate(70%, 0);
    z-index: 999;

    cursor: pointer;
    font-family: "Pretendard";
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    color: #0054d3;

    display: none;
    justify-content: space-between;
    align-items: center;
    padding-left: 22px;
    padding-right: 22px;
}
.btn-help:hover {
    text-decoration: none;
}
.partners-footer {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    height: 393px;
    width: 100%;
    padding-top: 69px;
    background: #000;
}
.partners-footer .wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.partners-footer .btn-text {
    font-weight: 400;
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    color: #fff;
}
.footer .btn-text:hover {
    text-decoration: none;
    color: #fff;
}
.partners-footer .line {
    margin: 0 10px;
    line-height: 30px;
    color: #fff;
}
.partners-footer .text {
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
    color: #a3a3a3;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pc_partners/PartnersFooter.vue